<template>
    <div class="container">
        <span><strong> EDITAR USUÁRIO </strong></span>
        <form class="myForm">
            <br>
            <div class="form-group row">
                <label class="col-sm-2 col-form-label">Usuário:</label>
                <div class="col-sm-10">
                    <input type="text" class="form-control" v-model="usuario" disabled>
                </div>
            </div>
            <div class="form-group row">
                <label class="col-sm-2 col-form-label">Nome:<span class="text-danger">*</span></label>
                <div class="col-sm-10">
                    <input type="text" class="form-control" v-model="nome">
                </div>
            </div>
            <div class="form-group row">
                <label class="col-sm-2 col-form-label">E-mail:<span class="text-danger">*</span></label>
                <div class="col-sm-10">
                    <input type="text" class="form-control" v-model="email">
                </div>
            </div>

            <div id="accordion">
                <div class="card">
                    <div class="card-header" id="headingOne">
                        <h5 class="mb-0">
                            <button type="button" class="btn" data-toggle="collapse" data-target="#collapseOne"
                                    aria-expanded="true" aria-controls="collapseOne">
                                <strong>Alterar Senha</strong>
                            </button>
                        </h5>
                    </div>

                    <div id="collapseOne" class="collapse hide" aria-labelledby="headingOne" data-parent="#accordion">
                        <div class="card-body">
                            <div class="form-group row">
                                <div class="col-sm-12">
                                    <label class="col-sm-12 col-form-label">Senha Atual:</label>
                                    <div class="col-sm-12">
                                        <input type="password" class="form-control" v-model="senhaAtual">
                                    </div>
                                </div>
                            </div>

                            <div class="form-group row">
                                <div class="col-sm-6">
                                    <label class="col-sm-6 col-form-label">Nova Senha:</label>
                                    <div class="col-sm-12">
                                        <input type="password" :disabled="(senhaAtual == '')" class="form-control" v-model="senha">
                                    </div>
                                </div>
                                <div class="col-sm-6">
                                    <label class="col-sm-6 col-form-label">Confirmar Senha:</label>
                                    <div class="col-sm-12">
                                        <input type="password" :disabled="(senha == '')" class="form-control" v-model="csenha">
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </form>
        <br>
        <div class="container text-right mt-2">
            <button class="btn btn-sm btn-danger" @click="retorno">Retornar</button>
            <button class="btn btn-sm btn-success ml-2" :disabled="(usuario == '' || nome == '' || email == '')" @click="salvar">
                Salvar
            </button>
        </div>
    </div>

</template>


<script>

    export default {
        name: 'CadastroContasEditar',

        data() {
            return {
                usuario: store.state.global.usuarioAtual.ba01_usuario,
                nome: store.state.global.usuarioAtual.ba01_nome,
                email: store.state.global.usuarioAtual.ba01_email,
                senhaAtual: '',
                senha: '',
                csenha: ''
            }
        },

        methods: {
            retorno() {
                this.$router.go(-1)
            },

            salvar() {
                let thisVue = this;

                if(this.senhaAtual != '') {
                    if(this.senhaAtual.lenght < 7){
                        this.$swal('A senha deve ter pelo menos 6 caracteres', 'Tente novamente', 'error');
                        return;
                    }
                    if(this.senha == '' || this.csenha == ''){
                        this.$swal('Preencha todos os campos para cadastrar uma nova senha', 'Tente novamente', 'error');
                        return;
                    }
                    if (this.senha !== this.csenha) {
                        this.$swal('As senhas não conferem', 'Tente novamente', 'error');
                        return;
                    }
                }
                let dados = {
                    ba01_usuario: this.usuario,
                    ba01_nome: this.nome,
                    ba01_email: this.email,
                    ba01_senha: this.senhaAtual,
                    ba01_cliente_id: store.state.global.usuarioAtual.ba01_cliente_id,
                    nova_senha: this.senha
                };

                api.enviarRequisicao('put', `api/controleacesso/usuarios/editaUsuario/${store.state.global.usuarioAtual.ba01_id}`, dados).then(resp => {
                    if(resp.data.erro){
                        thisVue.$swal(resp.data.erro,'','error')
                    }else if(resp.data.sucesso){
                        thisVue.$swal('Registro atualizado com sucesso','','success').then(function () {
                            store.dispatch('atualizarUsuario', resp.data.sucesso).then(function () {
                                window.location.replace(history.go(-1));
                            });
                        });
                    }else{
                        thisVue.$swal('Erro ao atualizar registro','','error');
                    }
                });
            }
        }
    }
</script>


<style scoped>
    .btn:focus {
        box-shadow: none;
    }
</style>
